import {client} from "./ApiClient";

export const renewPitcherCache = async (year: number): Promise<void> => {
  await client.post(`/admin/cache/pitcher?year=${year}`);
}

export const renewHitterCache = async (year: number): Promise<void> => {
  await client.post(`/admin/cache/hitter?year=${year}`);
}
